var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20h20V0H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    strokeWidth: 1.2,
    x: 3.154,
    y: 2.554,
    width: 13.8,
    height: 14.8,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.33c0 .223.048.434.135.624l-2.966-.001a.6.6 0 01-.098-1.192l.098-.008H9.49a1.495 1.495 0 00-.115.577zm4.145-.577a.6.6 0 01.097 1.192l-.097.008-1.28.001a1.494 1.494 0 00.02-1.202h1.26z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B65EE",
    cx: 10.873,
    cy: 7.332,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.886 12.297c0 .236.054.458.15.656H6.545a.6.6 0 01-.098-1.192l.098-.008 1.445-.002c-.067.17-.103.354-.103.546zm5.634-.544a.6.6 0 01.097 1.192l-.097.008h-2.784a1.494 1.494 0 00.048-1.202l2.736.002z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B65EE",
    cx: 9.386,
    cy: 12.292,
    r: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/assets/schedule.1ce95965.svg";
export { ForwardRef as ReactComponent };